<template>
  <div id="channel">
    <el-radio-group
      v-model="tabPosition"
      style="margin: 20px 0"
      v-loading="channelListLoading"
      :style="
        '--activeColor:' + selectColor + ';--unActiveColor:' + unselectColor
      "
    >
      <el-radio-button label="elrbtn-1" @click.native="changeStting"
        >展示设置</el-radio-button
      >
      <el-radio-button
        v-for="item in channel"
        v-bind:key="item.id"
        :label="'elrbtn' + item.id"
        @click.native="changeChannel(item.id, item.channelName)"
        >{{ item.channelName.replace("频道", "") }}频道</el-radio-button
      >
      <!-- <el-radio-button label="elrbtn0" @click.native="changeShopName"
        >系统名称</el-radio-button
      > -->
    </el-radio-group>
    <router-view v-bind:key="key"></router-view>
  </div>
</template>
<script>
import httpRequest from "../utils/httpRequest";
import channelConfig from '../utils/channel'
export default {
  name: "channel",
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  data() {
    return {
      type: null,
      id: -1,
      channel: [],
      channelListLoading: false,
      channelInfoLoading: false,
      tabPosition: "elrbtn-1",
      selectColor: "#0073a3",
      unselectColor: "#ffffff",
    };
  },
  created() {
    const name = this.$route.query.name;
    const id = this.$route.query.id;
    this.name = name || "展示设置";
    this.id = id || -1;
    this.getChannelAll();
    this.changeChannel(this.id, this.name);
  },
  methods: {
    getChannelAll() {
      this.channelListLoading = true;
      httpRequest
        .get("/api/shop/queryModuleChannelByCompanyId")
        .then((res) => {
          this.channel = res.data.list;
          this.channelListLoading = false;
        })
        .catch((e) => {
          this.channelListLoading = false;
        });
    },
    changeChannel(id, name) {
      this.tabPosition = "elrbtn" + id;
      let type = "channel";
      const c = channelConfig.find(
        (cs) => cs.name == name.replace("频道", "")
      );
      if (c) {
        type = c.path;
      }
      this.type = type;
      const url = "/" + type;
      this.$router.push({
        path: url,
        query: { name: name, id: id },
      });
    },
    changeShopName() {
      this.type = "channel";
      this.$router.push({
        path: "/channel",
        query: { name: "系统名称", id: 0 },
      });
    },
    changeStting() {
      this.type = "setting";
      this.$router.push({
        path: "/setting",
        query: { name: "展示设置", id: -1 },
      });
    },
  },
  watch: {
    $route(to, from) {
      this.name = this.$route.query.name;
      this.id = this.$route.query.id;
      this.$forceUpdate();
      this.changeChannel(this.id, this.name);
    },
  },
};
</script>
<style lang="less" scope>
#channel {
  .icon-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .icon-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .icon-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .icon-img {
    width: 60px;
    height: 60px;
    display: block;
  }
  .el-radio-button__inner {
    background: var(--unActiveColor);
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: var(--activeColor);
    border-color: var(--activeColor);
    -webkit-box-shadow: -1px 0 0 0 var(--activeColor);
    box-shadow: -1px 0 0 0 var(--activeColor);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/channel.vue